// Avatar — circular identity token. Shows an image or initials, sized in px.
// `status` adds a presence dot in the corner (color never the only cue — it
// pairs with a title for assistive tech).

export type AvatarStatus = 'online' | 'busy' | 'away' | 'offline';
/** Fill color of the initials avatar. Default 'brand'. */
export type AvatarTone = 'brand' | 'blue' | 'purple' | 'green' | 'amber' | 'red';

export interface AvatarProps {
  initials: string;
  src?: string;
  size?: number;
  alt?: string;
  /** Presence indicator dot. */
  status?: AvatarStatus;
  /** Fill color for the initials variant (ignored when an image is shown). */
  tone?: AvatarTone;
  className?: string;
}

const Avatar = ({
  initials,
  src = '',
  size = 34,
  alt = '',
  status,
  tone = 'brand',
  className = '',
}: AvatarProps) => {
  const classes = [
    'app-avatar',
    `app-avatar--${tone}`,
    status && 'app-avatar--has-status',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <span
      className={classes}
      style={{ width: size, height: size, fontSize: size * 0.4, overflow: 'visible' }}
    >
      {src ? (
        <img src={src} alt={alt} className='app-avatar__img' />
      ) : (
        <span className='app-avatar__initials'>{initials}</span>
      )}
      {status && (
        <span
          className={`app-avatar__status app-avatar__status--${status}`}
          title={status}
          aria-label={status}
        />
      )}
    </span>
  );
};

export default Avatar;
